module.exports = __webpack_public_path__ + "static/img/dia-event-btn.fbcafd1.jpg";